export const SELECT_MEALPLAN = 'SELECT_MEALPLAN';
export const SELECT_DURATION = 'SELECT_DURATION';
export const SELECT_ROOMTYPE = 'SELECT_ROOMTYPE';
export const SELECT_ARRIVAL = 'SELECT_ARRIVAL';

export const REQUEST_WIZARD_DATES = 'REQUEST_WIZARD_DATES';
export const RECEIVE_WIZARD_DATES = 'RECEIVE_WIZARD_DATES';

export const REQUEST_WIZARD_RATE = 'REQUEST_WIZARD_RATE';
export const RECEIVE_WIZARD_RATE = 'RECEIVE_WIZARD_RATE';

function shouldFetchWizardDates(state) {
  if (!state.dates) {
    return true;
  } if (state.wizardIsFetchingDates) {
    return false;
  }
  return false;
}

function buildWizardParams(state) {
  const params = {};

  state.type > -1 && (params.type = state.type);
  state.programCode && (params.p = state.programCode);
  state.rate.OfferId && (params.offerid = state.rate.OfferId);
  state.rate.Price && (params.price = state.rate.Price);
  state.selectedMealplan && (params.mp = state.selectedMealplan);
  state.selectedDuration && (params.du = state.selectedDuration);
  state.selectedRoomtype && (params.rc = state.selectedRoomtype.split('&b=')[0]) && (params.b = state.selectedRoomtype.split('&b=')[1]);
  state.selectedArrival && (params.df = state.selectedArrival);

  return Object.keys(params).map((k) => `${encodeURIComponent(k)}=${encodeURIComponent(params[k])}`).join('&');
}

function requestWizardDates(wizardDatesUrl) {
  return {
    type: REQUEST_WIZARD_DATES,
    wizardOptionsUrl: wizardDatesUrl,
  };
}

function fetchWizardDates(state, wizardDatesUrl, wizardRateUrl, fetchRate = false) {
  return (dispatch) => {
    const queryParams = buildWizardParams(state);
    wizardDatesUrl += (wizardDatesUrl.match(/\?/) ? '&' : '?') + queryParams;
    dispatch(requestWizardDates(wizardDatesUrl));
    return fetch(wizardDatesUrl)
      .then((response) => response.json())
      .then((json) => dispatch(receiveWizardDates(json)))
      .then(() => { fetchRate && dispatch(requestWizardRateIfNeeded(wizardRateUrl)); })
      .catch(() => dispatch(receiveWizardDates([])));
  };
}

function receiveWizardDates(dates) {
  return {
    type: RECEIVE_WIZARD_DATES,
    dates,
  };
}

export function requestWizardDatesIfNeeded(wizardDatesUrl, wizardRateUrl, action) {
  return (dispatch, getState) => {
    action && dispatch(action);
    const state = getState();
    if (shouldFetchWizardDates(state)) {
      return dispatch(fetchWizardDates(state, wizardDatesUrl, wizardRateUrl, Boolean(action)));
    }
  };
}

function requestWizardRate(wizardRateUrl) {
  return {
    type: REQUEST_WIZARD_RATE,
    wizardRateUrl,
  };
}

function fetchWizardRate(state, wizardRateUrl) {
  return (dispatch) => {
    const queryParams = buildWizardParams(state);
    wizardRateUrl += (wizardRateUrl.match(/\?/) ? '&' : '?') + queryParams;
    dispatch(requestWizardRate(wizardRateUrl));
    return fetch(wizardRateUrl)
      .then((response) => response.json())
      .then((json) => dispatch(receiveWizardRate(json)))
      .catch(() => dispatch(receiveWizardRate([])));
  };
}

function receiveWizardRate(rate) {
  return {
    type: RECEIVE_WIZARD_RATE,
    rate,
  };
}

export function requestWizardRateIfNeeded(wizardRateUrl, action) {
  return (dispatch, getState) => {
    action && dispatch(action);
    const state = getState();
    if (!state.wizardIsFetchingRate) {
      return dispatch(fetchWizardRate(state, wizardRateUrl));
    }
  };
}
